import { InterfaceMonitoringSearchCriteria } from "domain/entity/InterfaceMonitoring/InterfaceMonitoringSearchCriteria";
import { EbisInterfaceMonitoringMaintenanceConstant } from "presentation/constant/EbisInterfaceMonitoring/EbisInterfaceMonitoringMaintenanceConstant";
import { useEbisInterfaceMonitoringMaintenanceVM } from "presentation/hook/EbisInterfaceMonitoring/useEbisInterfaceMonitoringMaintenanceVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useEbisInterfaceMonitoringMaintenanceTracked } from "presentation/store/EbisInterfaceMonitoring/EbisInterfaceMonitoringMaintenanceProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import DateRangePickerComponent from "presentation/view/components/DateRangePickerComponent";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { useCallback, useMemo, useState } from "react";
import { FieldType, HPHButton, IconButton, IFieldValue, Loader } from "veronica-ui-component/dist/component/core";
import { SidebarActionBar, SidebarActionCross, Sidebarheader, SidebarTitle } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

export const EbisInterfaceMonitoringMainSearchPanel = () => {
    const [ebisInterfaceMonitoringState] = useEbisInterfaceMonitoringMaintenanceTracked();
    const ebisInterfaceMonitoringVM = useEbisInterfaceMonitoringMaintenanceVM();
    const SCREEN_CONSTANT = EbisInterfaceMonitoringMaintenanceConstant;
    const { searchCriteria } = ebisInterfaceMonitoringState;
    const messageBarVM = useMessageBarVM();
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const resetButtonClicked = useCallback(() => {
        ebisInterfaceMonitoringVM.onRemoveAllSearchCriteria();
    }, [ebisInterfaceMonitoringVM]);

    const searchButtonClicked = useCallback((searchCriteria: InterfaceMonitoringSearchCriteria) => {
        if (!searchCriteria.dateFrom || !searchCriteria.dateTo) {
            messageBarVM.showError("Must input Date (From) and Date (To) in search criteria.");
            return;
        }
        setIsLoading(true);
        ebisInterfaceMonitoringVM.setIsSearchLoading(true);
        ebisInterfaceMonitoringVM.onSearch(searchCriteria).then((data) => {
            setIsLoading(false);
            ebisInterfaceMonitoringVM.setIsSearchLoading(false);
        }).catch(error => {
            setIsLoading(false);
            ebisInterfaceMonitoringVM.setIsSearchLoading(false);
        })

    }, [ebisInterfaceMonitoringVM, messageBarVM])

    const memoMessageType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria?.messageType || ''}
                fieldValue={searchCriteria?.messageType}
                fieldLabel={SCREEN_CONSTANT.MESSAGE_TYPE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'messageType'}
                options={ebisInterfaceMonitoringState.dynamicOptions.messageTypeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    ebisInterfaceMonitoringVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [searchCriteria?.messageType, SCREEN_CONSTANT.MESSAGE_TYPE, ebisInterfaceMonitoringState.dynamicOptions.messageTypeDropdownOptions, ebisInterfaceMonitoringVM])

    const memoFrom = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria?.from || ''}
                fieldValue={searchCriteria?.from}
                fieldLabel={SCREEN_CONSTANT.FROM}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'from'}
                options={ebisInterfaceMonitoringState.dynamicOptions.formDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    ebisInterfaceMonitoringVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [searchCriteria?.from, SCREEN_CONSTANT.FROM, ebisInterfaceMonitoringState.dynamicOptions.formDropdownOptions, ebisInterfaceMonitoringVM])

    const memoTo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria?.to || ''}
                fieldValue={searchCriteria?.to}
                fieldLabel={SCREEN_CONSTANT.TO}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'to'}
                options={ebisInterfaceMonitoringState.dynamicOptions.toDropdownOptions}
                sort={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    ebisInterfaceMonitoringVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [searchCriteria?.to, SCREEN_CONSTANT.TO, ebisInterfaceMonitoringState.dynamicOptions.toDropdownOptions, ebisInterfaceMonitoringVM])

    const memoDateFromTo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "470px", marginBottom: "24px" }}>
            <DateRangePickerComponent
                label={SCREEN_CONSTANT.DATE_RANGE}
                width='470px'
                fieldNames={{ startField: "dateFrom", endField: "dateTo" }}
                dateRange={{ startDate: searchCriteria.dateFrom, endDate: searchCriteria.dateTo }}
                onDatesChange={ebisInterfaceMonitoringVM.onDateRangeChange}
            />
        </div>
        , [SCREEN_CONSTANT.DATE_RANGE, ebisInterfaceMonitoringVM.onDateRangeChange, searchCriteria.dateFrom, searchCriteria.dateTo])

    // const memoDateFrom = useMemo(() =>
    //     <div className='im-flex-row-item' style={{ width: "200px", marginBottom: "20px" }}>
    //         <DatePickerComponent
    //             disabled={false}
    //             optional={false}
    //             label={SCREEN_CONSTANT.DATE_FROM}
    //             width="200px"
    //             date={searchCriteria?.dateFrom}
    //             fieldName="dateFrom"
    //             errorMessage={""}
    //             onDateChange={ebisInterfaceMonitoringVM.onSearchFieldChange} />
    //     </div>
    //     , [SCREEN_CONSTANT.DATE_FROM, ebisInterfaceMonitoringVM.onSearchFieldChange, searchCriteria?.dateFrom])

    // const memoDateTo = useMemo(() =>
    //     <div className='im-flex-row-item' style={{ width: "200px", marginBottom: "20px" }}>
    //         <DatePickerComponent
    //             disabled={false}
    //             optional={false}
    //             label={SCREEN_CONSTANT.DATE_TO}
    //             width="200px"
    //             date={searchCriteria?.dateTo}
    //             fieldName="dateTo"
    //             errorMessage={""}
    //             onDateChange={ebisInterfaceMonitoringVM.onSearchFieldChange} />
    //     </div>
    //     , [SCREEN_CONSTANT.DATE_TO, ebisInterfaceMonitoringVM.onSearchFieldChange, searchCriteria?.dateTo])

    const memoStatus = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria?.status || ''}
                fieldValue={searchCriteria?.status}
                fieldLabel={SCREEN_CONSTANT.STATUS}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'status'}
                options={ebisInterfaceMonitoringState.dynamicOptions.statusDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    ebisInterfaceMonitoringVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [searchCriteria?.status, SCREEN_CONSTANT.STATUS, ebisInterfaceMonitoringState.dynamicOptions.statusDropdownOptions, ebisInterfaceMonitoringVM])

    return (
        <div className='side-form-content-left-wrapper' style={{ padding: "20px 20px 20px 0px" }}>
            <div className={'flex-row'}>
                <div className={'flex-row-item flex-row-item-full-width'}>
                    <Sidebarheader>
                        <SidebarTitle>{SCREEN_CONSTANT.SEARCH_CRITERIA}</SidebarTitle>
                        <SidebarActionCross>
                            <IconButton
                                fileName="Icon-cross" size="medium" toolTipText='Close' toolTipArrow={false} onClick={ebisInterfaceMonitoringVM.onSearchClick} />
                        </SidebarActionCross>
                    </Sidebarheader>
                </div>
            </div>

            {isLoading && <Loader Indicator="Spinner" size="Medium" />}

            <div className={'add-edit-form'} style={{ maxHeight: '75vh', height: '75vh', overflow: 'auto' }}>
                <div className="flex-row-auto">
                    <div className={'flex-row-item'}>
                        {/* Stack Form Start */}
                        <CriteriaItemContainer>
                            {memoMessageType}
                            {memoStatus}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoFrom}
                            {memoTo}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {/* {memoDateFrom}
                            {memoDateTo} */}
                            {memoDateFromTo}
                        </CriteriaItemContainer>
                    </div>
                </div>
            </div>
            <SidebarActionBar>
                <HPHButton label={'Reset'} size={'Small'} theme={'Secondary'} onClick={resetButtonClicked} />
                <HPHButton label={'Search'} size={'Small'} theme={'Primary'} onClick={() => searchButtonClicked(searchCriteria)} />
            </SidebarActionBar>
        </div>
    )
}
